import styled from 'styled-components';

import { Stack } from '@polyai/ui/components/atoms/Stack';
import StickySidebar from '@polyai/ui/components/molecules/StickySidebar';
import themeColors from '@polyai/ui/styles/config/colors';

export const FadingSidebar = styled(StickySidebar)<{
  $open: boolean;
}>`
  will-change: width;
  contain: layout style;

  border-right: 1px solid ${themeColors.borderSubtleInverse};
  transition: width 200ms cubic-bezier(0, 0, 0.37, 1.37);

  .accountName,
  .logoText,
  .buttonLabel,
  .buttonEndAdornment svg {
    opacity: ${({ $open }) => ($open ? 1 : 0.1)};
    transition: opacity 150ms ease-in-out;
  }

  .buttonLabel {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const NoSvgShrink = styled(Stack)`
  svg {
    flex-shrink: 0;
  }
`;

export const SkeletonRow = styled.div<{ $isExpanded: boolean }>`
  display: flex;
  justify-content: ${({ $isExpanded }) =>
    $isExpanded ? 'flex-start' : 'center'};
  width: 100%;
`;

export const SkeletonStack = styled(Stack)<{ $isExpanded: boolean }>`
  gap: ${({ theme }) => theme.spacing.xs3};
  align-items: center;
  justify-content: ${({ $isExpanded }) => ($isExpanded ? 'flex-start' : 'center')};
  width: 100%;
`;

export const AccountRow = styled(Stack)<{ $isExpanded: boolean }>`
  cursor: pointer;
  transition: background-color 150ms ease-in-out;

  &:hover {
    background-color: ${themeColors.backgroundPrimaryHover};

    > div:first-child {
      border: 1px solid ${themeColors.borderExtraStrongInverse};
    }
  }
`;
